import React, { Component } from "react";
import { connect } from "react-redux";

import { Wrapper, Row, Button, Icon } from "app/NativeComponents/common";

import MessageConversation from "app/DealMachineCore/snippets/MessageConversation";
import MessageAndNoteBox from "app/DealMachineCore/snippets/MessageAndNoteBox";
import SelectToNumber from "./SelectToNumber";
import PhoneNumberMore from "./PhoneNumberMore";
import OnboardingContainer from "app/DealMachineCore/snippets/OnboardingContainer";

import { checkIfUserHasModule } from "app/NativeActions";

class Messages extends Component {
  constructor(props) {
    super(props);
    const plan_module_info = checkIfUserHasModule({
      plan_modules: props.plan_modules,
      user: props.user,
      slug: "messages"
    });
    this.state = {
      selected_conversations: [],
      phone_number_more: false,
      plan_module_info
    };
    this._scroll_view = React.createRef();

    this.toggleMore = this.toggleMore.bind(this);
  }

  setSelectedConversations(lead_conversations, selected_to_number) {
    let selected_conversations = [];
    if (selected_to_number && lead_conversations) {
      for (let i = 0; i < lead_conversations.length; i++) {
        if (
          selected_to_number.owner_phone_number_id ==
          lead_conversations[i].lead_phone_number.owner_phone_number_id
        ) {
          selected_conversations.push(lead_conversations[i]);
        }
      }
    }
    this.setState({ selected_conversations });
  }

  componentDidMount() {
    this.setSelectedConversations(
      this.props.lead_conversations,
      this.props.selected_to_number
    );
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.lead_conversations !== this.props.lead_conversations ||
      prevProps.sending_message !== this.props.sending_message ||
      prevProps.selected_to_number !== this.props.selected_to_number
    ) {
      this.setSelectedConversations(
        this.props.lead_conversations,
        this.props.selected_to_number
      );
    }

    if (prevProps.user && prevProps.plan_modules) {
      if (
        this.props.plan_modules !== prevProps.plan_modules ||
        this.props.user.plan_modules !== prevProps.user.plan_modules
      ) {
        const plan_module_info = checkIfUserHasModule({
          plan_modules: this.props.plan_modules,
          user: this.props.user,
          slug: "messages"
        });
        this.setState({ plan_module_info: plan_module_info });
      }
    }
  }
  toggleMore(toggle) {
    this.setState({
      phone_number_more: toggle
    });
  }

  renderMoreButton() {
    if (this.props.selected_to_number) {
      return (
        <Button
          onPress={() => this.toggleMore(true)}
          style={{
            width: 40,
            height: 40,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Row>
            <Icon icon="more-vert" size={18} />
          </Row>
        </Button>
      );
    }
  }

  render() {
    if (this.props.user.team_clearance_level > 0) {
      if (
        this.state.plan_module_info &&
        (!this.state.plan_module_info.has_module ||
          this.props.card_info.bad_card == 1)
      ) {
        //render onboarding
        return (
          <OnboardingContainer
            slug="messages"
            contentful_slug="leadMessages"
            noContainer={true}
            noHeader={true}
            style={{
              padding: 20,
              backgroundColor: this.props.colors.card_color
            }}
            plan_module_info={this.state.plan_module_info}
          />
        );
      }

      return (
        <Wrapper
          style={{
            height: "100%"
          }}
        >
          {!this.props.keyboard_showing ? (
            <Row style={{ alignItems: "flex-start", paddingTop: 10 }}>
              <SelectToNumber {...this.props} />
              <Row
                style={{
                  flex: 1,
                  justifyContent: "flex-end",
                  height: 50,
                  alignItems: "center"
                }}
              >
                {this.renderMoreButton()}
              </Row>
            </Row>
          ) : null}
          <MessageConversation
            is_expanded={this.props.is_expanded}
            selected_to_number={this.props.selected_to_number}
            selected_conversations={this.state.selected_conversations}
            {...this.props}
          />
          <MessageAndNoteBox
            box_tab={"message"}
            selected_conversations={this.state.selected_conversations}
            include_tabs={
              this.state.selected_conversations &&
              this.state.selected_conversations.length > 0
            }
            disabled={
              !this.props.selected_to_number ||
              (this.props.selected_to_number &&
                this.props.selected_to_number.blocked == 1) ||
              (this.props.selected_to_number &&
                this.props.selected_to_number.do_not_call == 1) ||
              (this.props.selected_to_number &&
                this.props.selected_to_number.landline == 1) ||
              (this.props.selected_to_number &&
                this.props.selected_to_number.bad_phone == 1) ||
              (this.state.selected_conversations &&
                this.state.selected_conversations.length > 0 &&
                this.state.selected_conversations[0]
                  .awaiting_response_lock_out == 1) ||
              (this.state.selected_conversations &&
                this.state.selected_conversations.length > 0 &&
                this.state.selected_conversations[0].timezone_lock_out == 1)
            }
            onNoteSubmit={({ message, onSuccess = null }) => {
              const { token, active_property } = this.props;
              if (message.trim().length > 0) {
                this.props.postMessageNote({
                  token,
                  message_text: message,
                  lead_id: active_property.deal.id,
                  user: this.props.user,
                  conversation_id:
                    this.state.selected_conversations &&
                    this.state.selected_conversations.length > 0
                      ? this.state.selected_conversations[0].id
                      : null
                });

                if (onSuccess) {
                  onSuccess();
                }
              }
            }}
            onMessageSubmit={({ message, selected_from_number, onSuccess }) => {
              const { token, active_property } = this.props;
              if (message.trim().length > 0) {
                this.props.sendTextMessage({
                  token,
                  message_text: message,
                  media: null,
                  lead_id: active_property.deal.id,
                  conversation_id:
                    this.state.selected_conversations &&
                    this.state.selected_conversations.length > 0
                      ? this.state.selected_conversations[0].id
                      : null,
                  to_phone_number: this.props.selected_to_number
                    ? this.props.selected_to_number.phone_number
                    : null,
                  to_phone_number_id: this.props.selected_to_number
                    ? this.props.selected_to_number.owner_phone_number_id
                    : null,
                  from_phone_number: selected_from_number
                    ? selected_from_number.id
                    : null
                });

                if (onSuccess) {
                  onSuccess();
                }
              }
            }}
            selected_from_number={this.props.set_from_phone_number}
          />
          <PhoneNumberMore
            {...this.props}
            phone_number_more={this.state.phone_number_more}
            toggleMore={this.toggleMore}
          />
        </Wrapper>
      );
    }
    return <Wrapper />;
  }
}

export default Messages;
